/**
 * @file        src/components/NavStackRecorder.jsx
 * @description Renders nothing. Mounted once at the router root, it writes the
 *              current path into the history ledger (lib/navStack.js) on every
 *              navigation, so useStepBack can tell whether the browser's Back
 *              would land on the step a page's own Back button targets.
 *
 *              It lives at the ROOT (App.jsx), not inside AppLayout, so paths are
 *              recorded for the standalone legal routes too — otherwise a gap in
 *              the ledger would make a funnel Back fall back to replace-navigation
 *              for no reason.
 * @author      Kinetika Labs
 * @created     2026-08-03
 * @changelog
 *   - 2026-08-03 Claude — Initial.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordVisit } from '../lib/navStack.js';

export default function NavStackRecorder() {
  const { pathname } = useLocation();
  useEffect(() => { recordVisit(pathname); }, [pathname]);
  return null;
}
